export const partnersSidebar = () => {
    const sidebar = document.getElementById('sidebar');
    const overlay = document.getElementById('overlay');
    const toggleBtn = document.getElementById('partners-banner-button');
    const closeBtn = document.getElementById('closePartnersSidebar');


    if (sidebar) {
        function openSidebar() {
            sidebar.classList.add('active');
            overlay.classList.add('active');
        }

        function closeSidebar() {
            sidebar.classList.remove('active');
            overlay.classList.remove('active');
        }

        toggleBtn.addEventListener('click', openSidebar);
        closeBtn.addEventListener('click', closeSidebar);
        overlay.addEventListener('click', closeSidebar);

        // Show sidebar after form submit
        if (window.location.hash === "#contact-us") {
            openSidebar();
        }
    }

}
